import React from 'react'
import { css } from '@emotion/css'
import { LibraryReleaseDate } from '../library/library-release-date'
import {
  LibraryFormattedVersion,
  LibraryVersionUIProps
} from '../library/library-formatted-version'
import { Text } from '@contrast-security-inc/design-system-typography'
import { DotnetTooltip } from './dotnet-tooltip'
import { useIntl } from 'react-intl'

const latestVersionCss = css`
  display: flex;
  line-height: 18px;
`

const areVersionsEqual = (version, compare) => version !== compare

export function LatestVersionCell({
  releaseDate,
  version,
  compareVersion,
  language
}: {
  readonly releaseDate?: string
  readonly compareVersion: string
} & Pick<LibraryVersionUIProps, 'version' | 'language'>) {
  const { formatMessage } = useIntl()

  return (
    <div>
      {areVersionsEqual(version, compareVersion) ? (
        <>
          <DotnetTooltip language={language}>
            <LibraryFormattedVersion version={version} language={language} />
          </DotnetTooltip>
          <Text className={latestVersionCss} color="neutral60" font="metadata">
            <LibraryReleaseDate dateOnly={true} releaseDate={releaseDate} />
          </Text>
        </>
      ) : (
        <span className={latestVersionCss}>
          {formatMessage({ id: 'title_isLatestVersion' })}
        </span>
      )}
    </div>
  )
}
